export default {
  'accountSettings.title': 'Account',

  'accountSettings.field.restaurantName': 'Restaurant Name',
  'accountSettings.field.ownerName': 'Owner Name',
  'accountSettings.field.restaurantAddress': 'Restaurant Address',
  'accountSettings.field.restaurantWifi': 'Network Name:',
  'accountSettings.field.restaurantWifiPassword': 'Password',
  'accountSettings.field.email': 'Registered Email',
  'accountSettings.field.password': 'Login Password',
  'accountSettings.field.settlementTime': 'Settlement Time',
  'accountSettings.field.bankAccountLink': 'Bank Account Link',
  'accountSettings.field.payoutAccountLink': 'Payout Account Link',
  'accountSettings.field.payoutAccountLink.tooltip':
    'Please use this link to onboard a Stripe payout account. We will payout your card processing volume to the bank account linked to this account.',
  'accountSettings.field.invoicingAccountLink': 'Invoicing Account Link',
  'accountSettings.field.invoicingAccountLink.tooltip':
    'You can setup a Stripe invoicing account. We will use your invoicing account to deduct transaction fees. You may link the same or different bank account from the one you use for payout.',
  'accountSettings.account.blank': 'Click Here to Set Account',
  'accountSettings.editWifiInfo': 'Edit Wi-Fi Info',
  'accountSettings.field.closeoutReportCutoffTime': 'Closeout Report Cutoff Time',
  'accountSettings.field.closeoutReportCutoffTime.tooltip':
    'All reports are calculated based on a 24 hours time period. For example, if the cutoff time is set at 2:00:00 am, 1/1/2023’s reports would include data from 1/1/2023 1:59:59 am to 1/2/2023 2:00:00 am.',
  'accountSettings.time': 'Time',
  'accountSettings.startOfTheWeek': 'Start of the week',
};
